
import React, { Component, Fragment } from 'react';
import { base_url } from '../../globalConstants'
import { Table, Row, Col, Image, Nav, ButtonGroup, Button } from 'react-bootstrap';
import M from "materialize-css";
import { EditOutlined } from "@material-ui/icons";
import Axios from "axios";
import './addWarehouse.css';


class AddInvoiceEmailSetup extends Component {


  constructor(props) {
    super(props);
    this.state = ({
      owner_name: "", address_line_1: "", address_line_2: "",netterm:"",
      countryId: "", warehouseState: "", city: "", email: "", ccemail:"", phone_number:"",
      warehousedata: this.props.warehousedata,
      countrylist: this.props.countrylist, countrycodelist: this.props.country_code_list,
      statedata: this.props.statedata, stateCode_list: [], stateName_list:[],
      statelist: [], stateSelectOptions: [],
      countryName:"", mainId:"", keyId:"", stateCode:"", warehouseStateId:"", stateCodeDict:{}, tempStateList: {},
      editRow: false,
      // statelist: [{state_id: 1,state_name: "New Provience",state_code: "NP"}], 
    })

   
  }

  handleCountryNameChange = async (e) => {
    // this.setState({countryname: e.target.value})
    // @TODO: on changing countryname state list should also Change

    this.setState({ countryName: e.target.value })
    console.log("country selected:- " + e.target.value)
    // this.setState({countryname:e.target.value})


    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    console.log(selected_countryId)

    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    console.log(states)

    this.setState({ countryId: selected_countryId, statelist: states })
    // this.setState({statelist:states})
    console.log(this.state.countryId)
    console.log("state list")
    console.log(this.state.statelist)
    // this.state.statelist


    /////TESTTTTTTT  

    this.setState({ tempStateList: states })
    console.log(this.state.tempStateList)
    console.log(typeof this.state.tempStateList)
    
    /////TESTTTTTTTT END

  }

  handleOwnerNameChange = (e) => {
    this.setState({ owner_name: e.target.value })
  }
  handleAddressLineOneChange = (e) => {
    this.setState({ address_line_1: e.target.value })
  }
  handleAddressLineTwoChange = (e) => {
    this.setState({ address_line_2: e.target.value })
  }
  handleEmailChange = (e) => {
    this.setState({ email: e.target.value })
  }
  handleCCEmailChange = (e) => {
    this.setState({ ccemail: e.target.value })
  }
  
  handleNETChange = (e) => {
    this.setState({ netterm: e.target.value })
  }
  
  handlePhoneNumberChange = (e) => {
    this.setState({ phone_number: e.target.value })
  }
  handleStateChange = (e) => {
    console.log("state of ware house", e.target.value)
    this.setState({ warehouseState: e.target.value })
    console.log(this?.state?.warehouseState,"RRRRRRRRR");
  }

  handleCityChange = (e) => {
    this.setState({ city: e.target.value })
  }


//EDIT OPTION START
handleEditOption = (e) => {
  this.setState({editRow:true})
  var elems = document.getElementById("addWareHouseModal");
  var instance = M.Modal.init(elems);
  instance.open()

  let selectedRowIndex ;
              e = e || window.event;
              var data = [];
              var target = e.srcElement || e.target;
              // console.log(target.nodeName)
              while (target && target.nodeName !== "TR") {
                  target = target.parentNode;
                  selectedRowIndex= target.sectionRowIndex
                  console.log("Clicked row",target.sectionRowIndex)
                  // console.log(target.parentNode.index)
              }
              if (target) {
                  var cells = target.getElementsByTagName("td");
                  for (var i = 0; i < cells.length; i++) {
                      data.push(cells[i].innerHTML);
                  }
              }

              console.log(data);

              let country_name = this.state.countrylist[this.state.countrycodelist.indexOf(data[10])]
              console.log("Country name", country_name);

              const statesOnEdit = this.state.statedata[this.state.countrylist.indexOf(country_name)].slice()
              console.log(`States for the country ${country_name}:`)
              console.log(statesOnEdit,"LLLLLLLLLL");

              this.setState({ statelist: statesOnEdit })
              
                            //start on 150621
              let finalstatearr=[];

              for(var i=0;i<statesOnEdit.length;i++)
              {
                let statedataobj={
              state_id:statesOnEdit[i].state_id.toString(),
              state_name:statesOnEdit[i].state_name,
              state_code:statesOnEdit[i].state_code

                };
                finalstatearr.push(statedataobj);
              }

              console.log(finalstatearr);
              this.setState({ statelist: finalstatearr })

            var newArray = statesOnEdit.filter(function(item) {
              return item.state_code == data[9];
            });

            var setselectedstatevalue='';
            if(newArray && newArray.length>0)
            {
            setselectedstatevalue=newArray[0].state_id.toString();
            }

            console.log(newArray);
            ////end on 150621


              let stateNameCodeDict = {}
              for (var key in statesOnEdit) {              
                stateNameCodeDict[statesOnEdit[key].state_code] = statesOnEdit[key].state_name
              }
             console.log("stateNameCodeDict: ",stateNameCodeDict );

             console.log(`state name for state code ${data[9]} is`,stateNameCodeDict[data[9]] );
             
             let selStateName = stateNameCodeDict[data[9]]
             console.log(selStateName); 

              this.setState({mainId: data[0], keyId: data[12]})
              this.setState({
                //edit on 150621
                countryName: country_name, warehouseState: setselectedstatevalue, city: data[4],
                //countryName: country_name, warehouseState: selStateName, city: data[4],  
                owner_name: data[1], address_line_1: data[2], 
                address_line_2: data[3], phone_number: data[5],email:data[6],ccemail:data[7], netterm:data[8]
              })
}
openAddWarehouseDetailsModal =  ()=>{
  this.setState({editRow:false})      
  this.setState({
    owner_name: "", address_line_1: "", address_line_2: "",netterm:"",
    countryId: "", countryName:"", warehouseState: "", city: "", 
    warehouseStateId:"", phone_number: "", error:"",email:"",ccemail:""
  })
  //Here I am setting the state again on addwarehouse 

  var elems = document.getElementById("addWareHouseModal");
  var instance = M.Modal.init(elems);
  instance.open()
    
}
closeModal = ()=>{
  var elems = document.getElementById("addWareHouseModal");
  var instance = M.Modal.init(elems);
  instance.close();
  this.setState({editRow:false})
  this.setState({
    owner_name: "", address_line_1: "", address_line_2: "",netterm:"",
    countryId: "", countryName:"", warehouseState: "", city: "", 
    warehouseStateId:"", phone_number: "", error:"",email:"",ccemail:""
  })
}
updateWarehouseDetailsDB = async () => {

  let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.countryName)]
  let url = base_url+`invoiceemail/${this.state.keyId}/`

  // console.log(this.state.statename + this.state.statecode + this.state.countryname)
  var warehouseformdata = new FormData()
  warehouseformdata.append("owner_name", this.state.owner_name)
  warehouseformdata.append("address_line_1", this.state.address_line_1)
  warehouseformdata.append("address_line_2", this.state.address_line_2)
  warehouseformdata.append("netterm", this.state.netterm)
  warehouseformdata.append("city", this.state.city)
  warehouseformdata.append("phone_number", this.state.phone_number)
  warehouseformdata.append("email", this.state.email)
  warehouseformdata.append("cc_email", this.state.ccemail)
  warehouseformdata.append("country", country_code)
  warehouseformdata.append("state", this.state.warehouseState)
  // @Todo: APi to be called to save data for state

  try {
    let token = localStorage.getItem("token")
    var config = {
      headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
      
    };
    const response = await Axios.put(url, warehouseformdata, config)
    
    let itemIndex = parseInt(this.state.mainId) - 1
    this.state.warehousedata.splice(itemIndex, 1, response.data)
    
    // this.state.warehousedata.unshift(response.data)
    var elem = document.getElementById('addWareHouseModal')
    var instance = M.Modal.getInstance(elem);
    instance.close();
    M.toast({ html: 'Updated Invoice Email Setup Successfully.' , classes: "white-text orange rounded" })
    this.setState({
      owner_name: "", address_line_1: "", address_line_2: "",netterm:"",
    countryId: "", countryName:"", warehouseState: "", city: "", 
    warehouseStateId:"", phone_number: "", error:"",email:"",ccemail:""
    })
    this.setState({
      error: "",
      editRow: false
    })
  } catch (err) {
    this.setState({
      error: "OH Snap! Something is Wrong.Please try again",
      editRow: false
    })
    M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });

    console.log(err.message)
  }

}
//EDIT OPTION END

  addWareHouseToDB = async () => {
    // console.log(this.state.countryname + this.state.markup + this.state.rangeFinal)

    let state_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.warehouseState)]
    console.log(state_code);

    var warehouseformdata = new FormData()
    warehouseformdata.append("owner_name", this.state.owner_name)
    warehouseformdata.append("address_line_1", this.state.address_line_1)
    warehouseformdata.append("address_line_2", this.state.address_line_2)
    warehouseformdata.append("netterm", this.state.netterm)
    warehouseformdata.append("city", this.state.city)
    warehouseformdata.append("phone_number", this.state.phone_number)
	warehouseformdata.append("email", this.state.email)
  warehouseformdata.append("cc_email", this.state.ccemail)
    warehouseformdata.append("country", this.state.countryId)
    warehouseformdata.append("state", this.state.warehouseState)

    console.log(this.state.warehouseState,"iiiiiiiiiiii");

    try {

      let token = localStorage.getItem("token")
      let url = base_url+'invoiceemail/'  

      var config = {
        headers: { 
        'Content-Type': 'multipart/form-data' , 
        'Authorization':'Token '+ token},        
      };
      const response = await Axios.post(url, warehouseformdata, config)
      this.state.warehousedata.unshift(response.data)

      var elem = document.getElementById('addWareHouseModal')
      var instance = M.Modal.getInstance(elem);
      instance.close();
      this.setState({
        owner_name: "", address_line_1: "", address_line_2: "",netterm:"",
    countryId: "", countryName:"", warehouseState: "", city: "", 
    warehouseStateId:"", phone_number: "", error:"",email:"",ccemail:""
      })
      // @Todo: APi to be called to save data for SLAB
      M.toast({ html: 'Added WareHouse Successfully ', classes: "white-text orange rounded" })


    } catch (err) {
      this.setState({
        error: "OH Snap! Something is Wrong.Please try again"
      })
      M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });


    }
  }

  componentDidMount() {
    // Auto initialize all the things!
    M.AutoInit();
  }


  render() {
console.log(this.state.statelist,"nnnnnnnnnnnnnn")
    var uniquekey = 0
    var statekey = 0
    const selectCounrtyOptions = this.state.countrylist.map((country) => {
      return (
        <option key={uniquekey++} value={country}>{country}</option>
      )
    })
    const selectStateOptions = this.state.statelist.map((state) => {
      console.log("state", state)

      return (

        <option  key={statekey++} value={state.state_id}>{state.state_name}</option>
      )
    })
  
    var sr_no=0
    const warehousetable = this.state.warehousedata.map((warehouse) => {
      sr_no=sr_no+1
      return (
        <Fragment key={sr_no}>
          <tr>
            <td>{sr_no}</td>
            <td>{warehouse.owner_name}</td>
            <td>{warehouse.address_line_1}</td>
            <td>{warehouse.address_line_2}</td>
            <td>{warehouse.city}</td>
			<td>{warehouse.phone_number}</td>
			<td>{warehouse.email}</td>
      <td>{warehouse.cc_email}</td>
      <td>{warehouse.netterm}</td>
            <td>{warehouse.state_name}</td>
            <td>{warehouse.country}</td>
            
            <td onClick={this.handleEditOption}><a title = "Edit"><EditOutlined/></a></td>  
            <td className="hide">{warehouse.id}</td>
            <td className="hide"></td>
          </tr>
        </Fragment>

      )
    })
    const table_render = <Table hover >
      <thead>
        <tr>
          <th>Sr.No.</th>
          <th>Owner Name</th>
          <th>Address Line 1</th>
          <th>Address Line 2</th>
          <th>City</th>
		  <th>Phone Number</th>
		  <th>Email</th>
      <th>CC</th>
      <th>NET Term</th>
          <th>State</th>
          <th>Country</th>
          
          <th>Edit</th>                 
        </tr>
      </thead>
      <tbody>
        {warehousetable}
      </tbody>
    </Table>


    return (
      <Fragment>
        <br></br>
        <br></br>
        {/* <div className="">
    <AddCountry ref="child"/>
        </div> */}




        {/* <!-- Modal Trigger --> */}
        <div id="addWareHouseModal" className="modal modal-fixed-footer warehousemodal">
          <div className="modal-content">
          <h4 className="center orange-text"> {this.state.editRow ? "Update Invoice Email Details" : "Add Invoice Email Details "}</h4>
            <Row>
              <Col xs={12} >
                <form>
                  <p className="center red-text">{this.state.error}</p>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div >

                        {
                          this.state.editRow
                            ? <select id="country_name_selet" name="country" className="browser-default border-bottom " value={this.state.countryName} onChange={this.handleCountryNameChange}>
                              <option value="">Choose Invoice Email Country </option>
                              {selectCounrtyOptions}
                            </select>
                            : <select id="country_name_selet" name="country" className="browser-default " onChange={this.handleCountryNameChange}>
                              <option value="">Choose Invoice Email Country </option>
                              {selectCounrtyOptions}
                            </select>
                            }
                          <label>Select Country</label>

                        </div>
                      </div>  </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>

                          {
                            this?.state?.editRow
                              ? <select id="state_name_selet" name="stateName" className="browser-default" defaultValue={'DEFAULT'} value={this.state.warehouseState} onChange={this.handleStateChange}>
                                <option value="" disabled>Choose Invoice Email state </option>
                                {selectStateOptions }
                              </select>
                              : <select id="state_name_selet" name="stateName" className="browser-default" onChange={this.handleStateChange}>
                                <option value="DEFAULT" disabled>Choose Invoice state </option>
                                {selectStateOptions}
                              </select>
                          }
                          <label>Select state</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3">
                        <input name="warehouse_city" id="warehouse_citi" type="text" value={this.state.city} onChange={this.handleCityChange} className="" />
                        <label htmlFor="warehouse_citi" className={this.state.city?"black-text active":"black-text"}>Enter Invoice Email City</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Invoice Email City Ex: Miami</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name-="warehouseid" id="warehouse_id" className="materialize-textarea" type="text" value={this.state.owner_name}
                         onChange={this.handleOwnerNameChange} />
                        <label htmlFor="owner_name" className={this.state.owner_name?"black-text active":"black-text"}>Enter Owner Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Owner Name ex: WAR_001</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="address_line_1" id="address_line_1" type="text" value={this.state.address_line_1} onChange={this.handleAddressLineOneChange} className="" />
                        <label htmlFor="address_line_1" className={this.state.address_line_1?"black-text active":"black-text"}>Enter Address Line One</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address Line One ex: EzzyShip address_line_1</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3">
                        <input name="address_line_2" id="address_line_2" type="text" value={this.state.address_line_2} onChange={this.handleAddressLineTwoChange} className="" />
                        <label htmlFor="address_line_2" className={this.state.address?"black-text active":"black-text"}>Enter Address Line 2</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address Line 2 Ex: 112281 SW 133nd CT, Miami,FL</span>
                      </div>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="phone_number" id="phone_number" type="number" className="browser-default" value={this.state.phone_number} onChange={this.handlePhoneNumberChange} className="" />
                        <label htmlFor="phone_number" className={this.state.phone_number?"black-text active":"black-text"}>Enter Phone Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Phone Number Ex: 33186</span>
                      </div>
                    </Col>
                  </Row>
				  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email" id="email" type="text" className="browser-default" value={this.state.email} onChange={this.handleEmailChange} className="" />
                        <label htmlFor="email" className={this.state.email?"black-text active":"black-text"}>Enter Email</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email: email@ezzyship.com</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="ccemail" id="ccemail" type="text" className="browser-default" value={this.state.ccemail} onChange={this.handleCCEmailChange} className="" />
                        <label htmlFor="ccemail" className={this.state.email?"black-text active":"black-text"}>Enter CC Email</label>
                        <span className="helper-text left" data-error="wrong" data-success="">CC Email: email@ezzyship.com</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="netterm" id="netterm" type="number" className="browser-default" value={this.state.netterm} onChange={this.handleNETChange} className="" />
                        <label htmlFor="netterm" className={this.state.netterm?"black-text active":"black-text"}>Enter NET Term</label>
                        <span className="helper-text left" data-error="wrong" data-success="">NET Term (In Days): 7</span>
                      </div>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {/* <a href="#!" className="modal-close waves-effect waves-green btn-flat">Agree</a> */}

            <ButtonGroup className="mr-2" aria-label="First group">
              <Button id='cancelWareHouseBtn' variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
              {
              this.state.editRow
              ?<Button id="updateWareHouseBtn" variant="outline-primary" className="mr-2 btn" onClick = {this.updateWarehouseDetailsDB}>Update</Button>
              :<Button id="addWareHouseBtn" variant="outline-primary" className="mr-2 btn" onClick={this.addWareHouseToDB}> Add</Button>
              }   
            </ButtonGroup>

          </div>
        </div>
        <div className="">
          <Row>
            <Col xs={12} md={12} lg={12} >
              <div className="tableheight">
                {table_render}
              </div>
            </Col>

          </Row>
          <Row>
            <Col >
              <Nav className="right">
                <Nav.Link className="red-text modal-trigger " onClick={this.openAddWarehouseDetailsModal}>
                  Add Invoice Email Setup<Image className="red-text mr-auto" src="assets/images/plus-circle-red-m.svg"  /></Nav.Link>
              </Nav>
            </Col>
          </Row>
        </div>


      </Fragment>
    )
  }

}


export default AddInvoiceEmailSetup;